import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Banner, spacer12 } from '@spotify-internal/encore-web';
import styled from 'styled-components';

import { UserInfoContext } from 'context/UserInfo/UserInfoProvider';

import { Platform } from '../shared-constants';

const PaddedBanner = styled(Banner)`
  margin-bottom: ${spacer12};
`;

interface LoggedInBannerProps {
  platform: Platform | undefined;
}

export default ({ platform }: LoggedInBannerProps) => {
  const { data, userIsLoggedIn } = useContext(UserInfoContext);
  const { t } = useTranslation('content_policy_reporting');
  const isNonApp = [Platform.DESKTOP_WEB, Platform.DESKTOP, undefined].includes(platform);
  const [showBanner, setShowBanner] = useState(isNonApp);

  return (
    <>
      {showBanner && userIsLoggedIn && !!data?.email && (
        <PaddedBanner onClose={() => setShowBanner(false)}>
          <span
            dangerouslySetInnerHTML={{
              __html: t('user_logged_in_banner', {
                email: data.email || '',
                url: 'https://www.spotify.com/logout/',
              }),
            }}
          />
        </PaddedBanner>
      )}
    </>
  );
};
